import BrandAccount from "./BrandAccount-container";

/**
 * Export the top level component BrandAccount-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default BrandAccount;
